import React from "react";
import Page from "../../components/page/Page";
import PageHeader from "../../features/page-header/PageHeader";
import { Space } from "../../components/space/Space";
import { Search } from "../../components/search/Search";
import { MailCards } from "../../components/mail/mailCards";
import { CalendarComponent } from "../../components/calendar/CalendarComponent";
import { AssessmentsTable } from "../../components/open-assessments-table/AssessmentsTable";

export const Home: React.FC = () => {
    const title = "Property tax portal";

    return (
        <Page
            type="form"
            title={title}
            description={undefined}
            hasBreadcrumbs={false}
            actions={null}
        >
            <PageHeader />
            <Space size={"s"} />
            <Search />
            <Space size={"m"} />
            <MailCards />
            <Space size={"m"} />
            <AssessmentsTable />
            <Space size={"m"} />
            <CalendarComponent />
        </Page>
    );
};
